import { useIsMobile } from "@/hooks/useIsMobile";
import LottieFileInPage from "../../lib/lottie-files/LottieFileInPage";
import { LottieFileTypes } from "@/api/AppApi/services/company/interfaces/ICompany";
import { useRouter } from "@/app/components/lib/navigation/useRouter";
import { useTranslation } from "@/hooks/localization/useTranslations";
interface Props {
  menu?: boolean;
}
const CartEmpty: React.FC<Props> = ({ menu = false }) => {
  const t = useTranslation();
  const router = useRouter();
  const mobile = useIsMobile();
  return (
    <LottieFileInPage
      lottieFileType={LottieFileTypes.cart}
      title={t.cart_is_empty}
      text={t.add_items_to_cart}
      button={
        menu
          ? null
          : {
              onClick: () => router.replace("/"),
              content: t.start_shopping,
              isFullWidth: mobile,
            }
      }
    />
  );
};

export default CartEmpty;
